import React, { useEffect, useState } from 'react';
import { DataTableColumn } from '@common/components/datatable/types';
import { useTranslation } from 'react-i18next';
import { ApiGeneralStatistics } from './types';
import selectNetwork from '@modules/network/actions/select-network';
import { useThunkDispatch } from '@common/hooks';

export default (data: ApiGeneralStatistics) => {
  const { t } = useTranslation();
  const [columns, setColumns] = useState<DataTableColumn[]>([]);
  const dispatch = useThunkDispatch();

  const onOpenNetwork = async (id: string) => {
    const url = await dispatch(selectNetwork(id));
    if (url) window.open(url);
  };

  useEffect(() => {
    const baseColumns: DataTableColumn[] = [
      {
        key: 'network_name',
        label: t('organisation:general_statistics_community_name'),
        options: {
          align: 'left',
          sortable: true,
          render: (row: ApiGeneralStatistics) => {
            return (
              <a onClick={() => onOpenNetwork(row.network_id)} role="link">
                {row.network_name}
              </a>
            );
          },
        },
        className: 'tw-text-[--color-primary]',
      },
      {
        key: 'invited_users',
        label: t('organisation:general_statistics_invited_users'),
        options: {
          align: 'center',
          sortable: true,
        },
      },
      {
        key: 'registered_users',
        label: t('organisation:general_statistics_registered_users'),
        options: {
          align: 'center',
          sortable: true,
        },
      },
      {
        key: 'registered_users_percentage',
        label: t('organisation:general_statistics_registered_users_percentage'),
        options: {
          align: 'center',
          sortable: true,
        },
      },
      {
        key: 'active_users',
        label: t('organisation:general_statistics_active_users'),
        options: {
          align: 'center',
          sortable: true,
        },
      },
      {
        key: 'active_users_percentage',
        label: t('organisation:general_statistics_active_users_percentage'),
        options: {
          align: 'center',
          sortable: true,
        },
      },
      {
        key: 'posts_created',
        label: t('organisation:general_statistics_posts_created'),
        options: {
          align: 'center',
          sortable: true,
        },
      },
      {
        key: 'comments_created',
        label: t('organisation:general_statistics_comments_created'),
        options: {
          align: 'center',
          sortable: true,
        },
      },
      {
        key: 'likes_given',
        label: t('organisation:general_statistics_likes_given'),
        options: {
          align: 'center',
          sortable: true,
        },
      },
      {
        key: 'chat_messages_sent',
        label: t('organisation:general_statistics_chat_messages_sent'),
        options: {
          align: 'center',
          sortable: true,
        },
      },
    ];

    setColumns(baseColumns);
  }, [t, data]);

  return columns;
};
